/**
 * Heart toggle. Presentational; see RestaurantHeart for the wired version with the count.
 */
import { Heart } from "lucide-react";
import { cn } from "@/lib/utils";

interface HeartButtonProps {
  hearted: boolean;
  onToggle: () => void;
  disabled?: boolean;
  className?: string;
}

export function HeartButton({ hearted, onToggle, disabled, className }: HeartButtonProps) {
  return (
    <button
      type="button"
      aria-pressed={hearted}
      aria-label={hearted ? "Remove your heart" : "Heart this restaurant"}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      className={cn(
        "inline-flex size-8 items-center justify-center rounded-sm border text-brand transition-colors disabled:opacity-60",
        hearted ? "border-brand bg-brand-soft hover:bg-brand-soft/70" : "border-foreground bg-background hover:bg-brand-soft",
        className
      )}
    >
      <Heart className="size-3.5 fill-brand" strokeWidth={1.75} aria-hidden />
    </button>
  );
}
